import { __assign } from "tslib";
import { DeprecatedBaseButton } from '../deprecated-base-button/base-button.comp';
import * as React from 'react';
var defaultProps = {
    disabled: false
};
/** @deprecated please use \<Button/> */
export var DeprecatedButton = function (partialProps) {
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedHollowButton = function (partialProps) {
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { isHollow: true }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedAttentionButton = function (partialProps) {
    var type = 'attention';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { buttonType: type }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedSpecialButton = function (partialProps) {
    var type = 'special';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { buttonType: type }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedHollowSpecialButton = function (partialProps) {
    var type = 'special';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { isHollow: true, buttonType: type }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedHollowAttentionButton = function (partialProps) {
    var type = 'attention';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return (React.createElement(DeprecatedBaseButton, __assign({}, props, { isHollow: true, buttonType: type }), props.children));
};
/** @deprecated please use \<Button/> */
export var DeprecatedDangerButton = function (partialProps) {
    var type = 'danger';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { buttonType: type }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedHollowDangerButton = function (partialProps) {
    var type = 'danger';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return (React.createElement(DeprecatedBaseButton, __assign({}, props, { isHollow: true, buttonType: type }), props.children));
};
/** @deprecated please use \<Button/> */
export var DeprecatedPositiveButton = function (partialProps) {
    var type = 'positive';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { buttonType: type }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedHollowPositiveButton = function (partialProps) {
    var type = 'positive';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return (React.createElement(DeprecatedBaseButton, __assign({}, props, { isHollow: true, buttonType: type }), props.children));
};
/** @deprecated please use \<Button/> */
export var DeprecatedPremiumButton = function (partialProps) {
    var type = 'premium';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { buttonType: type }), props.children);
};
/** @deprecated please use \<Button/> */
export var DeprecatedHollowPremiumButton = function (partialProps) {
    var type = 'premium';
    var props = __assign(__assign({}, defaultProps), partialProps);
    return React.createElement(DeprecatedBaseButton, __assign({}, props, { buttonType: type, isHollow: true }), props.children);
};
//# sourceMappingURL=button.js.map